import { Modal } from "src/Components";
import { CoveredMatrixOrderItemTableReport } from "src/Interfaces/coveredMatrixOrder";

export const VolumeDetailValue=({ label,value }: {
  label: string;
  value: number|null|undefined;
}) => <div className="bg-white px-3 py-2">
    <div className="mb-1 text-[11px] text-gray-500">{label}</div>
    <div className="text-sm font-semibold text-gray-800" dir="ltr">
      {value===null||value===undefined? "-":Number(value).toLocaleString()}
    </div>
  </div>;

export const MatrixItemVolumeDetailsModal=({ row,onClose }: {
  row: CoveredMatrixOrderItemTableReport;
  onClose: () => void;
}) => <Modal
    onClose={onClose}
    UI={<div className="w-[620px] max-w-[92vw] p-4" dir="rtl">
      <div className="mb-4 border-b pb-3">
        <div className="font-bold">جزئیات حجمی ریزسفارش کاوردکال</div>
        <div className="mt-1 text-xs text-gray-500">{row.optionSymbolName||row.optionIsin}</div>
      </div>
      <div className="mb-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
        <div className="rounded bg-sky-50 p-3">
          <div className="text-xs text-gray-600">حجم انجام برحسب نماد پایه</div>
          <div className="mt-1 text-lg font-bold text-sky-800" dir="ltr">
            {Number(row.doneBaseEquivalentVolume||0).toLocaleString()}
          </div>
        </div>
        <div className="rounded bg-sky-50 p-3">
          <div className="text-xs text-gray-600">اندازه قرارداد</div>
          <div className="mt-1 text-lg font-bold text-sky-800" dir="ltr">
            {row.optionContractSize===null||row.optionContractSize===undefined
              ? "-"
              :Number(row.optionContractSize).toLocaleString()}
          </div>
        </div>
      </div>
      <div className="space-y-4">
        <section>
          <div className="mb-2 text-xs font-bold">ارسال‌شده</div>
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            <VolumeDetailValue label="حجم خام سمت نماد پایه" value={row.baseSentVolume} />
            <VolumeDetailValue label="حجم خام سمت آپشن" value={row.optionSentVolume} />
          </div>
        </section>
        <section>
          <div className="mb-2 text-xs font-bold">حجم باز</div>
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
            <VolumeDetailValue label="حجم باز پایه" value={row.baseOpenVolume} />
            <VolumeDetailValue label="حجم باز آپشن (قرارداد)" value={row.optionOpenVolume} />
            <VolumeDetailValue label="حجم باز آپشن (معادل دارایی پایه)" value={row.optionEquivalentOpenVolume} />
          </div>
        </section>
        <section>
          <div className="mb-2 text-xs font-bold">حجم انجام</div>
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
            <VolumeDetailValue label="حجم انجام پایه" value={row.baseDoneVolume} />
            <VolumeDetailValue label="حجم انجام آپشن (قرارداد)" value={row.optionDoneVolume} />
            <VolumeDetailValue
              label="حجم انجام آپشن (معادل دارایی پایه)"
              value={row.optionEquivalentDoneVolume}
            />
          </div>
        </section>
        <section>
          <div className="mb-2 text-xs font-bold">ناترازی</div>
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
            <VolumeDetailValue label="ناترازی سمت پایه" value={row.baseImbalanceVolume} />
            <VolumeDetailValue label="ناترازی سمت آپشن (قرارداد)" value={row.optionImbalanceVolume} />
            <VolumeDetailValue
              label="ناترازی سمت آپشن (معادل دارایی پایه)"
              value={row.optionEquivalentImbalanceVolume}
            />
          </div>
        </section>
        <section>
          <div className="mb-2 text-xs font-bold">امکان ارسال</div>
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            <VolumeDetailValue label="امکان اعتباری" value={row.creditAvailability} />
            <VolumeDetailValue label="امکان غیر اعتباری" value={row.nonCreditAvailability} />
          </div>
        </section>
      </div>
    </div>}
  />;
